export default {
    centerSlide: {
        slide: [{
            "name": "Procurement Management",
            "children": [
                {
                    "name": "Purchase Orders",
                },
            ]
        },
        {
            "name": "Customer Service",
            "children": [
                {
                    "name": "Refunds/After-sales",
                },
            ]
        },
        {
            "name": "Finance",
            "children": [
                {
                    "name": "Credit Application",
                },
                {
                    "name": "Credit Limit",
                },
                {
                    "name": "Payment Term Settlement",
                },
                {
                    "name": "Pending Bills",
                },
                {
                    "name": "Invoice Management",
                },
                {
                    "name": "Contract Management",
                },
            ]
        },
        {
            "name": "Settings",
            "children": [
              {
                    "name": "Account Information",
                },
                {
                    "name": "Account Security",
                },
                {
                    "name": "My Verification",
                },
                {
                    "name": "Address Management",
                }
            ]
        },
        {
            "name": "Favorites Center",
            "children": [
              {
                    "name": "Saved Products",
                },
                {
                    "name": "Saved Stores",
                },
            ]
        }
        ]
    }
}